import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgReachRatePerVideoConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.avg_reach_rate_per_video',
    id: 'average_reach_rate_per_video',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    tooltip: 'kpi.tiktok.tooltip_avg_reach_rate_per_video',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_33,
    mergedData: true,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
